import { render, staticRenderFns } from "./LogicData.vue?vue&type=template&id=5274b91b"
import script from "./LogicData.vue?vue&type=script&lang=js"
export * from "./LogicData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports